export enum SearchParams {
  Country = 'country',
  UserSignature = 'userSignature',
  AuthCode = 'authCode',
  CodeVerifier = 'codeVerifier',
  SubmissionId = 'submissionId',
  OrganisationId = 'organisationId',
}
